export class LoadingHost {}